"use client"

import { useEffect, useState } from "react"
import ClickmapTracker from "./clickmap"
import PageViewTracker from "./page-view-tracker"
import HeatmapBridge from "./heatmap-bridge"
import { isHeatmapPreview } from "./preview"

// Single entry point wrapping the app: captures clicks (react-clickmap) and
// time-on-page (use-page-view). Both run unconditionally — the capture is
// cookie-free and collects no PII, so it isn't gated on cookie consent.
//
// When the page is embedded in the admin heatmap viewer (`?pa_heatmap=1`) we
// skip capture entirely and only run the scroll-sync bridge, so previewing a
// page never pollutes its own analytics.
export default function PageAnalytics({
  children,
}: {
  children: React.ReactNode
}) {
  // Resolve preview mode after mount to avoid any SSR/CSR markup mismatch.
  const [preview, setPreview] = useState(false)
  useEffect(() => {
    setPreview(isHeatmapPreview())
  }, [])

  if (preview) {
    return (
      <>
        {children}
        <HeatmapBridge />
      </>
    )
  }

  return (
    <ClickmapTracker>
      {children}
      <PageViewTracker />
      <HeatmapBridge />
    </ClickmapTracker>
  )
}
